import { useGetFTUXHomeTakeoverFlowQuery } from "../../services/ftuxService";
import { useSelector } from "react-redux";

const FTUXBootstrapper = () => {
  const creatorLoggedIn = useSelector((s) => s.appReducer.creatorLoggedIn);
  useGetFTUXHomeTakeoverFlowQuery(undefined, {
    refetchOnFocus: false,
    refetchOnReconnect: false,
    pollingInterval: 0,
    skip: !creatorLoggedIn,
  });
  return null;
};

export default FTUXBootstrapper;
